import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/case-studies/consumer-electronics/page.tsx");
